import { DatePipe } from '@angular/common';
import { Pipe } from '@angular/core';
import { XsI18nPipe } from './xs-i18n.pipe';

@Pipe({
  name: 'time-format',
})
export class TimeFormatPipe {
  constructor(private xsi18n: XsI18nPipe, private datePipe: DatePipe) {}

  transform(date: number, shortForm?: boolean, dueDate?: boolean, timezone?: string) {
    const now = new Date();
    const curDate = new Date(date);

    // Get difference in seconds
    const diff = Math.abs((now.getTime() - curDate.getTime()) / 1000);

    // get the seconds of one day
    const secondsInDay = 60 * 60 * 24;

    // Is the date in the future?
    const future = curDate > now;

    let caption: string;

    if (diff < 60) {
      // Less than a minute difference

      return this.xsi18n.transform('timeFormatFilter_Now');
    } else if (
      diff <= 60 * 60 ||
      (now.getDate() === curDate.getDate() &&
        now.getMonth() === curDate.getMonth() &&
        now.getFullYear() === curDate.getFullYear())
    ) {
      // Same day
      const diffInHours = Math.floor(diff / 3600);
      const minutesRemainder = Math.floor(diff / 60) - diffInHours * 60;
      let formatedHour: string;
      let formatedMins: string;
      let formatedHoursMinutes: string;
      let timeFormatCapture: string;
      if (shortForm) {
        caption = future ? 'timeFormatFilter_HoursMinutes_Caption' : 'timeFormatFilter_HoursMinutesAgo_Caption';
        formatedHour = this.xsi18n.transform('timeFormatFilter_FormatedHours', diffInHours);
        formatedMins =
          minutesRemainder > 0 ? this.xsi18n.transform('timeFormatFilter_FormatedMinutes', minutesRemainder) : '';
      } else {
        caption = future ? 'timeFormatFilter_InHoursMinutes_Caption' : 'timeFormatFilter_HoursMinutesAgo_Caption';
        timeFormatCapture =
          diffInHours > 1 ? 'timeFormatFilter_Long_FormatedHours' : 'timeFormatFilter_Long_FormatedHour';
        formatedHour = this.xsi18n.transform(timeFormatCapture, diffInHours);

        timeFormatCapture =
          minutesRemainder > 1 ? 'timeFormatFilter_Long_FormatedMinutes' : 'timeFormatFilter_Long_FormatedMinute';
        formatedMins = this.xsi18n.transform(timeFormatCapture, minutesRemainder);
      }

      if (diffInHours === 0) {
        formatedHour = '';
      }

      if (minutesRemainder === 0) {
        formatedMins = '';
      }

      formatedHoursMinutes = this.xsi18n.transform('timeFormatFilter_FormatedHourMinutes', formatedHour, formatedMins);
      return this.xsi18n.transform(caption, formatedHoursMinutes.trim());
    } else if (isYesterDay(now, curDate)) {
      // if it is yesterday
      if (shortForm) {
        if (dueDate) {
          // if time format is for dueDate
          caption = 'timeFormatFilter_Due_DayAgo_Caption';
          return this.xsi18n.transform(caption, '1');
        }

        return this.xsi18n.transform('timeFormatFilter_Yesterday');
      }

      return (
        this.xsi18n.transform('timeFormatFilter_Long_Yesterday') +
        this.datePipe.transform(date, this.xsi18n.transform('timeFormatFilter_Long_Time'), timezone)
      );
    } else if (isTomorrow(now, curDate)) {
      // the date is tomorrow
      if (shortForm) {
        if (dueDate) {
          return this.xsi18n.transform('timeFormatFilter_Due_Tomorrow');
        }
        return this.xsi18n.transform('timeFormatFilter_MonthDay_Format');
      }
      const diffInHours = Math.ceil(diff / 3600);
      return (
        this.xsi18n.transform('timeFormatFilter_Long_Tomorrow') +
        this.datePipe.transform(date, this.xsi18n.transform('timeFormatFilter_Long_Time'), timezone) +
        this.xsi18n.transform('timeFormatFilter_Long_InHours_Caption', diffInHours)
      );
    } else if (!shortForm) {
      let result = this.datePipe.transform(
        date,
        this.xsi18n.transform('timeFormatFilter_Long_MonthDayYearHourMinutes_Format'),
        timezone
      );
      if (diff / secondsInDay < 30) {
        if (future) {
          caption = 'timeFormatFilter_Long_InDays_Caption';
        } else {
          caption = 'timeFormatFilter_Long_DaysAgo_Caption';
        }

        result += ' ' + this.xsi18n.transform(caption, Math.ceil(diff / secondsInDay));
      }
      return result;
    } else if (now.getFullYear() === curDate.getFullYear()) {
      // Same year
      return this.datePipe.transform(date, this.xsi18n.transform('timeFormatFilter_MonthDay_Format'), timezone);
    } else {
      // Different year
      if (isYearOld(now, curDate) && !dueDate) {
        return this.datePipe.transform(date, this.xsi18n.transform('timeFormatFilter_Year_Format'), timezone);
      }
      return this.datePipe.transform(date, this.xsi18n.transform('timeFormatFilter_MonthDayYear_Format'), timezone);
    }
  }
}

export const isYesterDay = (now: Date, curDate: Date): boolean => {
  const yesterDay: Date = new Date(now.getTime());
  yesterDay.setDate(now.getDate() - 1);
  return (
    curDate.getDate() === yesterDay.getDate() &&
    curDate.getMonth() === yesterDay.getMonth() &&
    curDate.getFullYear() === yesterDay.getFullYear()
  );
};

export const isTomorrow = (now: Date, curDate: Date): boolean => {
  const tomorrow: Date = new Date(now.getTime());
  tomorrow.setDate(now.getDate() + 1);
  return (
    curDate.getDate() === tomorrow.getDate() &&
    curDate.getMonth() === tomorrow.getMonth() &&
    curDate.getFullYear() === tomorrow.getFullYear()
  );
};

export const isYearOld = (now: Date, curDate: Date): boolean => {
  const lastYear = new Date(now.getTime());
  lastYear.setFullYear(now.getFullYear() - 1);
  return curDate <= lastYear;
};
